module.exports = __webpack_public_path__ + "media/icons/plus-circle-a43713bf.svg";